export default {
  black: '#21201F',
  white: '#FFFFFF',
  gray: {
    50: '#F7FAFC',
    100: '#EDF2F7',
    200: '#E2E8F0',
    300: '#CBD5E0',
    400: '#A0AEC0',
    500: '#718096',
    600: '#4A5568',
    700: '#2D3748',
    800: '#1A202C',
    900: '#171923',
  },
  red: {
    50: '#FDE9E7',
    100: '#FAC1BD',
    200: '#F69993',
    300: '#F37168',
    400: '#F15B50',
    500: '#EF493E',
    600: '#BC1A10',
    700: '#8D140C',
    800: '#5E0D08',
    900: '#2F0704',
  },
  orange: {
    50: '#FFF9E6',
    100: '#FEEDB9',
    200: '#FFC528',
    300: '#FBB525',
    400: '#F68C28',
    500: '#F26E21',
    600: '#C14E0B',
    700: '#913B08',
    800: '#602706',
    900: '#301403',
  },
  yellow: {
    50: '#FFF9E6',
    100: '#FEEDB9',
    200: '#FDE28B',
    300: '#FDD65E',
    400: '#FCCB31',
    500: '#FCC003',
    600: '#C99903',
    700: '#977302',
    800: '#654D01',
    900: '#322601',
  },
  green: {
    50: '#F0FFF4',
    100: '#C6F6D5',
    200: '#9AE6B4',
    300: '#68D391',
    400: '#48BB78',
    500: '#38A169',
    600: '#2F855A',
    700: '#276749',
    800: '#22543D',
    900: '#1C4532',
  },
  teal: {
    50: '#E6FFFA',
    100: '#B2F5EA',
    200: '#81E6D9',
    300: '#4FD1C5',
    400: '#38B2AC',
    500: '#319795',
    600: '#2C7A7B',
    700: '#285E61',
    800: '#234E52',
    900: '#1D4044',
  },
  blue: {
    50: '#ECF2F9',
    100: '#CADAED',
    200: '#A7C2E1',
    300: '#85AAD6',
    400: '#6392CA',
    500: '#4079BC',
    600: '#346298',
    700: '#2B338C',
    800: '#1A314C',
    900: '#1D295B',
  },
  cyan: {
    50: '#E5FBFF',
    100: '#B8F5FF',
    200: '#8AEFFF',
    300: '#5CE8FF',
    400: '#02EEFF',
    500: '#00BEDD',
    600: '#00AFCC',
    700: '#0090B9',
    800: '#07788A',
    900: '#002C33',
  },
  purple: {
    50: '#FAF5FF',
    100: '#E9D8FD',
    200: '#D6BCFA',
    300: '#B794F4',
    400: '#9F7AEA',
    500: '#805AD5',
    600: '#6B46C1',
    700: '#553C9A',
    800: '#44337A',
    900: '#322659',
  },
  pink: {
    50: '#FFF5F7',
    100: '#FED7E2',
    200: '#FBB6CE',
    300: '#F687B3',
    400: '#ED64A6',
    500: '#D53F8C',
    600: '#B83280',
    700: '#97266D',
    800: '#702459',
    900: '#521B41',
  },
  apex: {
    midnightBlue: '#1D295B',
    darkSlateBlue: '#2B338C',
    cornflowerBlue: '#4079BC',
    link: '#4079BC',
    darkCyan: '#07788a',
    steelBlue: '#0090B9',
    deepSkyBlue: '#00BEDD',
    orangeRed: '#EF493E',
    coral: '#F26E21',
    darkOrange: '#F68C28',
    orange: '#FBB525',
    goldenRod: '#FFC528',
    gold: '#FDD968',
    yellow: '#FFFF00',
    green: '#35A65A',
    forestGreen: '#2A8448',
    seaGreen: '#238563',
    darkSlateGray: '#2F4F4F',
    slateGray: '#708090',
    dimGray: '#696969',
    lightSlateGray: '#778899',
    black: '#21201F',
    indigo: '#4B0082',
    rebeccaPurple: '#663399',
    slateBlue: '#6A5ACD',
    lemonChiffon: '#FFFACD',
    lightYellow: '#FFFFE0',
    ghostWhite: '#F8F8FF',
    gray: '#808080',
    darkGray: '#A9A9A9',
    silver: '#C0C0C0',
    lightGray: '#D3D3D3',
    gainsboro: '#DCDCDC',
    whiteSmoke: '#F5F5F5',
    white: '#FFFFFF',
  },
}
